"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createInitialsAvatarStyle;

function createInitialsAvatarStyle(_ref) {
  var accent = _ref.accent,
      avatarSize = _ref.avatarSize,
      botAvatarBackgroundColor = _ref.botAvatarBackgroundColor,
      primaryFont = _ref.primaryFont,
      userAvatarBackgroundColor = _ref.userAvatarBackgroundColor;
  return {
    '&.webchat__initialsAvatar': {
      alignItems: 'center',
      color: 'White',
      fontFamily: primaryFont,
      height: avatarSize,
      justifyContent: 'center',
      overflow: 'hidden',
      width: avatarSize,
      '&.webchat__initialsAvatar--fromUser': {
        backgroundColor: userAvatarBackgroundColor || accent
      },
      '&:not(.webchat__initialsAvatar--fromUser)': {
        backgroundColor: botAvatarBackgroundColor || accent
      }
    }
  };
}